// @generated by protoc-gen-es v1.10.0 with parameter "target=ts"
// @generated from file penumbra/core/component/community_pool/v1/community_pool.proto (package penumbra.core.component.community_pool.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck
import { Message, proto3 } from "@bufbuild/protobuf";
import { AssetId, Value } from "../../../asset/v1/asset_pb.js";
/**
 * CommunityPool parameter data.
 *
 * @generated from message penumbra.core.component.community_pool.v1.CommunityPoolParameters
 */
export class CommunityPoolParameters extends Message {
    /**
     * Whether Community Pool spend proposals are enabled.
     *
     * @generated from field: bool community_pool_spend_proposals_enabled = 1;
     */
    communityPoolSpendProposalsEnabled = false;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.core.component.community_pool.v1.CommunityPoolParameters";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "community_pool_spend_proposals_enabled", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    ]);
    static fromBinary(bytes, options) {
        return new CommunityPoolParameters().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CommunityPoolParameters().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CommunityPoolParameters().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CommunityPoolParameters, a, b);
    }
}
/**
 * CommunityPool genesis state.
 *
 * @generated from message penumbra.core.component.community_pool.v1.GenesisContent
 */
export class GenesisContent extends Message {
    /**
     * CommunityPool parameters.
     *
     * @generated from field: penumbra.core.component.community_pool.v1.CommunityPoolParameters community_pool_params = 1;
     */
    communityPoolParams;
    /**
     * The initial balance of the Community Pool.
     *
     * @generated from field: penumbra.core.asset.v1.Value initial_balance = 2;
     */
    initialBalance;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.core.component.community_pool.v1.GenesisContent";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "community_pool_params", kind: "message", T: CommunityPoolParameters },
        { no: 2, name: "initial_balance", kind: "message", T: Value },
    ]);
    static fromBinary(bytes, options) {
        return new GenesisContent().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GenesisContent().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GenesisContent().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GenesisContent, a, b);
    }
}
/**
 * Requests the list of all asset balances associated with the Community Pool.
 *
 * @generated from message penumbra.core.component.community_pool.v1.CommunityPoolAssetBalancesRequest
 */
export class CommunityPoolAssetBalancesRequest extends Message {
    /**
     * (Optional): The specific asset balances to retrieve, if excluded all will be returned.
     *
     * @generated from field: repeated penumbra.core.asset.v1.AssetId asset_ids = 2;
     */
    assetIds = [];
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.core.component.community_pool.v1.CommunityPoolAssetBalancesRequest";
    static fields = proto3.util.newFieldList(() => [
        { no: 2, name: "asset_ids", kind: "message", T: AssetId, repeated: true },
    ]);
    static fromBinary(bytes, options) {
        return new CommunityPoolAssetBalancesRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CommunityPoolAssetBalancesRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CommunityPoolAssetBalancesRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CommunityPoolAssetBalancesRequest, a, b);
    }
}
/**
 * The Community Pool's balance of a single asset.
 *
 * @generated from message penumbra.core.component.community_pool.v1.CommunityPoolAssetBalancesResponse
 */
export class CommunityPoolAssetBalancesResponse extends Message {
    /**
     * The balance for a single asset.
     *
     * @generated from field: penumbra.core.asset.v1.Value balance = 1;
     */
    balance;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.core.component.community_pool.v1.CommunityPoolAssetBalancesResponse";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "balance", kind: "message", T: Value },
    ]);
    static fromBinary(bytes, options) {
        return new CommunityPoolAssetBalancesResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CommunityPoolAssetBalancesResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CommunityPoolAssetBalancesResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CommunityPoolAssetBalancesResponse, a, b);
    }
}
